export default {"src":"/_next/static/media/andhra pradesh.e1405fbb.svg","height":336,"width":310,"blurWidth":0,"blurHeight":0};